import React from "react";
import { Field, FieldProps, FieldRenderProps } from "react-final-form";
import { InputGroup, InputGroupText } from "reactstrap";
import "./TextFieldV2.scss";

export interface ITextFieldProps<FieldValue>
  extends FieldProps<FieldValue, FieldRenderProps<FieldValue, HTMLInputElement | HTMLTextAreaElement>> {
  label?: string;
  light?: boolean;
  type?: string;
  appendText?: string;
  prependText?: string;
  placeholder?: string;
  multiline?: boolean; // Render a textarea if true
  bare?: boolean; // render only the input
  inputProps?: any;
}

const TextField: React.FC<ITextFieldProps<string>> = ({
  label,
  light,
  appendText,
  prependText,
  disabled,
  placeholder,
  multiline,
  bare,
  inputProps,
  ...fieldProps
}) => {
  return (
    <Field {...fieldProps}>
      {({ input, meta }) => {
        const hasError = meta.touched && !!meta.error;

        const containerClass = disabled
          ? "text-field-disabled-v2"
          : hasError
            ? "text-field-error-v2"
            : light
              ? "text-field-light-v2"
              : "text-field-dark-v2";

        if (bare) {
          return (
            <div className={containerClass}>
              <InputGroup>
                <input
                  {...(input as React.InputHTMLAttributes<HTMLInputElement>)}
                  {...inputProps}
                  disabled={disabled}
                  placeholder={placeholder}
                  aria-invalid={hasError}
                />
              </InputGroup>
              {hasError && <span>{meta.error}</span>}
            </div>
          );
        }

        return (
          <div className={containerClass}>
            <ul>
              {label && (
                <li>
                  <label>{label}</label>
                </li>
              )}
              <li>
                <InputGroup>
                  {prependText && <InputGroupText>{prependText}</InputGroupText>}

                  {multiline ? (
                    <textarea
                      {...(input as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
                      className="textarea-custom"
                      disabled={disabled}
                      placeholder={placeholder}
                      aria-invalid={hasError}
                    />
                  ) : (
                    <input
                      {...(input as React.InputHTMLAttributes<HTMLInputElement>)}
                      {...inputProps}
                      disabled={disabled}
                      placeholder={placeholder}
                      aria-invalid={hasError}
                    />
                  )}

                  {appendText && <InputGroupText>{appendText}</InputGroupText>}
                </InputGroup>
              </li>
              {hasError && <span>{meta.error}</span>}
            </ul>
          </div>
        );
      }}
    </Field>
  );
};

export default TextField;
